<template>
    <v-flex v-if="dataProvider.imageSrc" @click="f_click()" align-self-center xs12 :class="(dataProvider.route ? 'cliquable' : '') + ' ' + (dataProvider.size ? dataProvider.size : 'md4')">
        <v-img :src="$icsilab.getUrlImage(dataProvider.imageSrc)" :height="dataProvider.imageHeight ? dataProvider.imageHeight : '300'" contain></v-img>
    </v-flex>
    <v-flex v-else-if="dataProvider.map" align-self-center xs12 :class="(dataProvider.route ? 'cliquable' : '') + ' ' + (dataProvider.size ? dataProvider.size : 'md4')">
        <v-img :src="dataProvider.map" contain></v-img>
    </v-flex>
    <v-flex v-else class="fx-card" xs12 @click="f_click()" :class="(dataProvider.route ? 'cliquable' : '') + ' ' + (dataProvider.size ? dataProvider.size : 'md4')">
        <v-hover>
            <template v-slot="{ hover }">
                <v-card flat class="transparent" :elevation="dataProvider.elevation ? hover ? dataProvider.elevation.hover : dataProvider.elevation.initial : 0">
                    <v-card-text v-if="dataProvider.icon" class="text-center">
                        <v-icon x-large :color="dataProvider.iconColor ? dataProvider.iconColor : '#09203F'">{{dataProvider.icon}}</v-icon>
                    </v-card-text>
                    <v-card-text v-else-if="dataProvider.iconImage" class="text-center">
                        <div style="display: flex;justify-content: center" v-if="dataProvider.iconImage">
                            <v-img :src="$icsilab.getUrlImage(dataProvider.iconImage)" :height="dataProvider.iconImageHeight ? dataProvider.iconImageHeight : 60" contain></v-img>
                        </div>
                    </v-card-text>
                    <!--<v-card-title class="headline" v-if="dataProvider.titre" :style="{color: (dataProvider.titreColor ? dataProvider.titreColor : '#000000'),justifyContent: (dataProvider.titreAlign ? dataProvider.titreAlign : 'center')}" v-html="dataProvider.titre">
                    </v-card-title>-->
                    <v-card-title class="headline" v-if="dataProvider.titre" :style="{color: (dataProvider.titreColor ? dataProvider.titreColor : '#000000'),justifyContent: (dataProvider.titreAlign ? dataProvider.titreAlign : 'center')}">
                        <h4>{{dataProvider.titre}}</h4>
                    </v-card-title>
                    <!--<v-card-subtitle class="title" v-if="dataProvider.sousTitre" :style="{color: (dataProvider.sousTitreColor ? dataProvider.sousTitreColor : '#000000'),textAlign: (dataProvider.sousTitreAlign ? dataProvider.sousTitreAlign : 'center')}"  v-html="dataProvider.sousTitre"  >
                    </v-card-subtitle>-->
                    <v-card-subtitle class="title" v-if="dataProvider.sousTitre" :style="{color: (dataProvider.sousTitreColor ? dataProvider.sousTitreColor : '#000000'),textAlign: (dataProvider.sousTitreAlign ? dataProvider.sousTitreAlign : 'center')}">
                        <h4>{{dataProvider.sousTitre}}</h4>
                    </v-card-subtitle>
                    <v-card-text class="body-1" v-if="dataProvider.content" :style="{color: (dataProvider.contentColor ? dataProvider.contentColor : '#000000'),textAlign: dataProvider.contentAlign}" >
                        <span v-html="dataProvider.content"></span>
                    </v-card-text>
                </v-card>
            </template>
        </v-hover>
    </v-flex>
</template>
<script>
    export default {
        name: "FxCard",
        props: {
            dataProvider: {
                type: Object,
                default: null
            }
        },
        methods: {
            f_click() {
                if (this.dataProvider.route && ( this.$route.name != this.dataProvider.route) ) {
                    this.$icsilab.goToPage(this.dataProvider.route)
                }
            }
        }
    }
</script>
<style scoped>
    .cliquable:hover {
        cursor: pointer;
        /*
        box-sizing: border-box;
        border: 1px solid grey;
        border-radius: 15px;
        */
    }

</style>